import { Text, TextField } from '@/components/design-system'

interface UserInfoData {
  name: string
  phone_number: string
}

interface Props {
  data: UserInfoData
  onChange: (field: keyof UserInfoData, value: string) => void
}

export default function UserInfoStep({ data, onChange }: Props) {
  return (
    <div className="space-y-8">
      <div>
        <Text as="h1" size="display-small" className="font-bold text-foreground">
          Bem-vindo a StationZero
        </Text>
        <Text as="p" size="body-large" color="subdued" className="mt-2">
          Vamos começar com seus dados básicos.
        </Text>
      </div>

      <div className="space-y-5">
        <TextField
          label="Seu nome"
          value={data.name}
          onChange={(value) => onChange('name', value)}
          placeholder="John Snow"
          required
          autoFocus
          autoComplete="name"
        />

        <TextField
          label="Telefone (WhatsApp)"
          value={data.phone_number}
          onChange={(value) => onChange('phone_number', value)}
          placeholder="(11) 98765-4321"
          type="tel"
          helpText="Use um número com WhatsApp"
          autoComplete="tel"
        />
      </div>
    </div>
  )
}
